var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurityCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "68px",
    height: "45px",
    viewBox: "0 0 68 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Debit/Credit Card") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Debit/Credit-Card",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(44.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#AEC6DA",
    strokeWidth: 0.7,
    cx: 9,
    cy: 10,
    r: 8.65
  }), /*#__PURE__*/React.createElement("text", {
    id: 123,
    fontFamily: "SourceSansPro-Regular, Source Sans Pro",
    fontSize: 8,
    fontWeight: "normal",
    "line-spacing": 19,
    letterSpacing: 0.285714286,
    fill: "#004EE7"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 3,
    y: 8
  }, "123"))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#DEE9F6",
    x: 0,
    y: 7,
    width: 68,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#B2C6D8",
    x: 0.5,
    y: 0.5,
    width: 67,
    height: 44,
    rx: 6
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityCode);
export default __webpack_public_path__ + "static/media/Security Code.4819541943358408cbf8288e8150dc80.svg";
export { ForwardRef as ReactComponent };